import React from 'react';
import { useParams } from 'react-router-dom';
import { StudyGuideBlock } from '@/pages/study-guide/study-guide-block';
import { learningPathEndpoints } from './block-endpoints';
import { PATHS } from '@/routes/paths';

export function LearningPathBlock() {
  const { blockId } = useParams();
  return (
    <StudyGuideBlock
      endpoints={learningPathEndpoints(blockId)}
      // Fallback para a última trilha acessada: o endpoint de bloco não expõe user-learning-path-id,
      // então /trilha/atual redireciona para a instância correta via last_accessed_at no backend.
      backRoute={PATHS.LEARNING_PATH.CURRENT}
      backLabel="Trilha"
    />
  );
}
